import { Goal } from "./goals/goals";

export enum State {
    DEFAULT = 'DEFAULT',
    GOAL_CREATE = 'GOAL_CREATE',
    GOAL_EDIT = 'GOAL_EDIT'
}

export interface CallbackParam {
    newState: State,
    goal?: Goal
}
